import styled from 'styled-components';

export const Container = styled.div`
    background: #f4f5fc;
    height: auto;
    width: 100%;
    display: flex;
    flex-direction: column;
    z-index: 100;
}
`;

export const H1 = styled.h1`
    font-size: 20px;
    margin-top: 0;
    margin-bottom: 0.5em;
    color: rgb(82, 82, 113);
    font-weight: 500;
}
`;
